<template>
  <div :class="['input-container', {focused: isLabelCollapsed}]">
    <input
      v-on="$listeners"
      v-model="__modelValue"
      ref="basePasswordInput"
      :id="inputId"
      :class="['password', {has_error: invalid}]"
      :name="inputName"
      type="password"
      maxlength=""
      @focus="handleInputFocus"
      @blur="handleInputBlur"
    />

    <label :for="inputId" class="placeholder-label">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'BasePasswordFormInput',
  emits: ['update:modelValue'],
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    inputId: {
      type: String,
      default: 'inputPassword'
    },
    inputName: {
      type: String,
      default: 'password'
    },
    invalid: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isInputFocused: false,
      isAutoFilled: false
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.basePasswordInput && this.$refs.basePasswordInput.addEventListener) {
        this.$refs.basePasswordInput.addEventListener('animationstart', this.handleAnimation)
      }
    })
  },
  computed: {
    __modelValue: {
      get () {
        return this.modelValue
      },
      set (value) {
        this.$emit('update:modelValue', value)
      }
    },
    isLabelCollapsed () {
      return !!this.__modelValue || this.isInputFocused || this.isAutoFilled
    }
  },
  methods: {
    handleInputFocus () {
      this.isInputFocused = true
    },
    handleInputBlur () {
      this.isInputFocused = false
    },
    handleAnimation (e) {
      this.isAutoFilled = e.animationName === 'onAutoFillStart'
    }
  },
  beforeDestroy () {
    if (this.$refs.basePasswordInput && this.$refs.basePasswordInput.removeEventListener) {
      this.$refs.basePasswordInput.removeEventListener('animationstart', this.handleAnimation)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/formInput/BasePasswordFormInput.vue